import * as React from "react";
import { keyframes } from "@emotion/core";
import { borderColor, size as boxSize } from "polished";
import styled from "../../styled";

interface DonutSpinnerProps {
  color: string;
  duration: number;
  size: number;
  strokeWidth: number;
}

const contourColor = "rgba(0, 0, 0, 0.1)";
const rotateAnimation = keyframes({
  from: { transform: "rotate(0deg)" },
  to: { transform: "rotate(360deg)" },
});

export const DonutSpinner: React.FC<DonutSpinnerProps> = styled("span")(({
  color,
  duration,
  size,
  strokeWidth,
}) => ({
  animationDuration: `${duration}ms`,
  animationIterationCount: "infinite",
  animationName: rotateAnimation.toString(),
  animationTimingFunction: "linear",
  display: "inline-block",
  ...borderColor(contourColor, contourColor, contourColor, color),
  borderRadius: "50%",
  borderStyle: "solid",
  borderWidth: strokeWidth,
  ...boxSize(size),
}));
